<template>

    <div class="flex gap-2 items-center mb-6">
        <h4 class=" cb-text-h4 ">Settlements</h4>
        <a href="#link" class="cb-text-copy-base btn-link no-underline flex gap-1 items-center h-auto">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd"
                    d="M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z"
                    clip-rule="evenodd" />
            </svg>
            <span>View Settlement Holidays</span>
        </a>
    </div>

    <div class="flex flex-wrap overflow-hidden sm:-mx-2 mb-8 gap-8">

        <div class=" w-[60%] overflow-hidden">
            <!-- Column Content -->

            <div class="flex flex-col gap-3 w-full overflow-hidden">
                <!-- Column Content -->
                <h5 class="cb-text-h5">Settlements Summary</h5>
                <InsightCard title="Settled Amount (All Time)" data="$1,205,213.32">

                    <svg class="w-full" viewBox="0 0 438 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M109.339 24.2344C65.8108 30.5125 1 29.9701 1 29.9701V51.001H437V12.763C437 12.763 368.727 0.967983 326.018 1.76955C282.926 2.57831 260.354 12.6634 217.679 17.0647C175.618 21.4026 151.005 18.2249 109.339 24.2344Z"
                            fill="url(#paint0_linear_4687_9266)" />
                        <path
                            d="M1 29.9701C1 29.9701 65.8108 30.5125 109.339 24.2344C151.005 18.2249 175.618 21.4026 217.679 17.0647C260.354 12.6634 282.926 2.57831 326.018 1.76955C368.727 0.967983 437 12.763 437 12.763"
                            stroke="#0052CC" stroke-width="2" />
                        <line x1="1" y1="51.6367" x2="437" y2="51.6367" stroke="#ECECF8" />
                        <defs>
                            <linearGradient id="paint0_linear_4687_9266" x1="238.423" y1="1.73047" x2="238.423"
                                y2="51.001" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#0B3DEF" stop-opacity="0.34" />
                                <stop offset="1" stop-color="white" stop-opacity="0.08" />
                            </linearGradient>
                        </defs>
                    </svg>


                </InsightCard>
            </div>

            <div class="w-full overflow-hidden sm:mt-2 ">
                <!-- Column Content -->
                <div class="flex flex-wrap overflow-hidden sm:-mx-2">

                    <div class="w-1/2 overflow-hidden sm:px-2">
                        <!-- Column Content -->
                        <InsightCard title="On The Way To Your Bank Account" data="$1,205.40"></InsightCard>
                    </div>

                    <div class="w-1/2 overflow-hidden sm:px-2">
                        <!-- Column Content -->
                        <InsightCard title="On Hold" data="$5,213.02"></InsightCard>

                    </div>

                </div>
            </div>

        </div>

        <div class=" w-[37%] overflow-hidden ">
            <!-- Column Content -->

            <div class="flex w-full h-full flex-wrap overflow-hidden sm:-mx-2">

                <div class="w-full overflow-hidden gap-4 sm:px-2">
                    <h5 class="cb-text-h5">Estimated Future Settlements</h5>
                    <p class="cb-text-copy-regular">The estimated settlement amount can be changed.</p>
                </div>

                <div class="w-full h-fit overflow-hidden sm:my-2 sm:px-2">
                    <InsightCard>

                        <div class="flex flex-col w-full">
                            <!-- Tabs with underline -->
                            <div class="w-full">
                                <div class="form-control sm:hidden">
                                    <label for="tabs" class="label">Select a tab</label>
                                    <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
                                    <select id="tabs" name="tabs" class="select">
                                        <option selected>Aug 29, 2022</option>

                                        <option>Aug 30, 2022</option>
                                    </select>
                                </div>
                                <div class="hidden sm:block">
                                    <div class="border-b border-neutral-200">
                                        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                                            <!-- Current: "tab-link_active", Default: "border-transparent tab-link_inactive" -->
                                            <a href="#" class="tab-link tab-link_active" aria-current="page"> Aug 29,
                                                2022</a>

                                            <a href="#" class="tab-link tab-link_inactive"> Aug 30, 2022 </a>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-col gap-3 justify-start items-start divide-y-2 w-full mt-5 mx-auto">

                                <div class="flex flex-col gap-3 justify-start items-start w-full">
                                    <div class="flex flex-row justify-between items-start w-full">
                                        <p class="block cb-text-copy-small ">Expected Amount</p>
                                        <p class="block cb-text-copy-small text-gray-900 ">$20,251</p>
                                    </div>

                                    <div class="flex flex-row justify-between items-start w-full">
                                        <p class="block cb-text-copy-small ">Expected Amount</p>
                                        <p class="block cb-text-copy-small text-gray-900 ">$20,251</p>
                                    </div>

                                    <div class="flex flex-row justify-between items-start w-full">
                                        <p class="block cb-text-copy-small ">Expected Amount</p>
                                        <p class="block cb-text-copy-small text-gray-900 ">$20,251</p>
                                    </div>
                                </div>

                                <div class="flex flex-row justify-between items-start w-full pt-2">
                                    <p class="block cb-text-copy-regular">Estimated Settlement Amount</p>
                                    <p class="block cb-text-copy-small text-gray-900  font-semibold">$15,411.02</p>
                                </div>
                            </div>

                        </div>

                    </InsightCard>
                </div>

            </div>
        </div>

    </div>

    <Tabs />

    <div class="filters flex gap-4 mb-6 mt-4">




        <div v-click-outside="()=>onClickOutside(0)" class="form-control w-min">
            <div @click="Option[0]= !Option[0]" class="form-control w-auto">
                <div @click="Option1= !Option1" class="mt-1  relative">
                    <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                        aria-labelledby="listbox-label">
                        <span class="w-full inline-flex truncate">
                            <span class="select-secondary-text">Period:</span>
                            <span class="truncate ml-1 black font-medium"> All time </span>
                        </span>
                        <span class="select-button-icon-container">
                            <!-- Heroicon name: solid/selector -->
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                    clip-rule="evenodd" />
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
            <ul tabindex="-1" v-show="Option[0]" class="select-ul max-w-[180px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li-selected group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> All time </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Yesterday </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 1 week </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 1 month </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 3 months </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 6 months </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 1 year </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <!-- More items... -->
            </ul>
        </div>



        <div v-click-outside="()=>onClickOutside(1)" class="form-control w-auto">
            <div @click="Option[1]= !Option[1]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Status:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>
            <ul tabindex="-1" v-show="Option[1]" class="select-ul max-w-[196px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="In Progress" aria-describedby="comments-description" name="In Progress" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="In Progress" class="text-gray-700 label">In Progress</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Success" aria-describedby="comments-description" name="Success" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Success" class="text-gray-700 label">Success</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Void" aria-describedby="comments-description" name="Void" checked type="checkbox"
                                class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Void" class="text-gray-700 label">Void</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Failed" aria-describedby="comments-description" name="Failed" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Failed" class="text-gray-700 label">Failed</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Timeout" aria-describedby="comments-description" name="Timeout" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Timeout" class="text-gray-700 label">Timeout</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Needs Attention" aria-describedby="comments-description" name="Needs Attention"
                                checked type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Needs Attention" class="text-gray-700 label">Needs Attention</label>
                        </div>
                    </div>
                </li>


                <!-- More items... -->
            </ul>
        </div>

        <div v-click-outside="()=>onClickOutside(2)" class="form-control w-auto">
            <div @click="Option[2]= !Option[2]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Type:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>
            <ul tabindex="-1" v-show="Option[2]" class="select-ul max-w-[216px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Authorization" aria-describedby="comments-description" name="Authorization"
                                checked type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Authorization" class="text-gray-700 label">Authorization</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Payment" aria-describedby="comments-description" name="Payment" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Payment" class="text-gray-700 label">Payment</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Refund" aria-describedby="comments-description" name="Refund" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Refund" class="text-gray-700 label">Refund</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Payment Reversal" aria-describedby="comments-description" name="Payment Reversal"
                                checked type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Payment Reversal" class="text-gray-700 label">Payment Reversal</label>
                        </div>
                    </div>
                </li>



                <!-- More items... -->
            </ul>
        </div>

        <div v-click-outside="()=>onClickOutside(3)" class="form-control w-auto">
            <div @click="Option[3]= !Option[3]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Amount:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>
        </div>

        <div v-click-outside="()=>onClickOutside(4)" class="form-control w-auto">
            <div @click="Option[4]= !Option[4]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Payment method:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>

            <ul tabindex="-1" v-show="Option[4]" class="select-ul max-w-[216px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Card" aria-describedby="comments-description" name="Card" checked type="checkbox"
                                class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Card" class="text-gray-700 label">Card</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="ACH Credit" aria-describedby="comments-description" name="ACH Credit" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="ACH Credit" class="text-gray-700 label">ACH Credit</label>
                        </div>
                    </div>
                </li>


                <!-- More items... -->
            </ul>
        </div>

    </div>
    <Table />



</template>

<script>
import Tabs from "./Tabs.vue";
import vClickOutside from 'click-outside-vue3'
import Table from './Table.vue'
import InsightCard from './InsightCard.vue'


export default {
    name: "Settlements",
    components: {
        Tabs,
        Table,
        InsightCard
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        onClickOutside(param) {
            this.Option[param] = false
        }
    },
    data() {
        return {
            Option: [false, false, false, false, false],

        }
    }
};

</script>